import { DD, initializeRum } from '@tcc/analytics';

declare global {
  interface Window {
    fieldViewRumInitialized?: boolean;
  }
}

const tracedApiServices = [
  'hank',
  'groot',
  'mycroft',
  'deere',
  'fields',
  'mosaic',
  'fieldview',
  'eva',
  'planting',
  'walter',
  'user-config',
  'user',
].join('|');

if (!window.fieldViewRumInitialized) {
  window.fieldViewRumInitialized = true;

  initializeRum({
    applicationId: '5735ee39-1865-4edc-9b79-09ed301c17aa',
    clientToken: 'pub0c9b9b4ce81b52c27cc300e0db1bff47',
    site: 'datadoghq.com',
    service: 'fieldview-new-arch',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: false,
    trackResources: true,
    trackLongTasks: true,
    trackViewsManually: true,
    defaultPrivacyLevel: 'mask',
    allowedTracingUrls: [
      {
        match: new RegExp(`^https://(?:api\\.)?climate\\.com/api/(?:${tracedApiServices})/`),
        propagatorTypes: ['datadog'],
      },
      {
        match: /^https:\/\/(?:api\.)?climate\.com\/api\/v5\/farms\//,
        propagatorTypes: ['datadog'],
      },
      {
        match: /^https:\/\/(?:api\.)?climate\.com\/v(?:1|2)\/graphql$/,
        propagatorTypes: ['datadog'],
      },
      {
        match: /^https:\/\/ol\.na\.climate\.com\/(?:v(?:1|2)|slam)\/graphql$/,
        propagatorTypes: ['datadog'],
      },
      { match: 'https://uapi.climate.com/app/graphql', propagatorTypes: ['datadog', 'tracecontext'] },
    ],
    propagateTraceBaggage: false,
    env: process.env.NODE_ENV,
    version: process.env.npmPackageVersion,
  });

  window.DD_RUM = DD.getDatadogRumInstance();
}

/**
 * Reports an error to Datadog RUM under a stable, unique error name so it groups
 * into its own Error Tracking issue, while preserving the original message and
 * stack. Non-Error values are coerced to an Error. Use at catch boundaries where
 * an error would otherwise be swallowed or go unhandled.
 */
export const reportError = (
  errorName: string,
  error: unknown,
  context?: Record<string, unknown>,
): void => {
  const reportable = error instanceof Error ? error : new Error(String(error));
  reportable.name = errorName;
  DD.addError(reportable, context);
};

